
import { useHead } from '@unhead/vue'
import { computed } from 'vue'
import router from '@/router'


/*
|--------------------------------------------------------------------------
| Helpers
|--------------------------------------------------------------------------
*/

function canonicalUrl(path) {

    if (path === '/') {
        return 'https://flystaygo.com/'
    }

    return 'https://flystaygo.com' + path.replace(/\/$/, '')
}


function makeSlugTitle(value) {

    value = value.replace(/[-_]/g, ' ')
    value = value.replace(/\s+/g, ' ')

    return value
        .trim()
        .replace(/\b\w/g, c => c.toUpperCase())
}


/*
|--------------------------------------------------------------------------
| SEO Service
|--------------------------------------------------------------------------
*/



    /*
        * Return all dynamic <head> information
        * for the supplied Vue Router route.
        */
function getHead(route) {

        const path = route.path

        let title =
            'FlyStayGo Travel | Hotels, Tours, Flights & Cars'

        let description =
            'FlyStayGo Travel Network helps you discover hotels, tours, flights, car rentals and travel destinations around the world.'

        let robots =
            'index, follow'

        let type =
            'WebPage'

        const canonical =
            canonicalUrl(path)


        /*
        |--------------------------------------------------------------------------
        | HOME
        |--------------------------------------------------------------------------
        */

        if (path === '/') {

            title =
                'FlyStayGo Travel | Hotels, Tours, Flights & Cars'

            description =
                'Discover hotels, tours, flights and car rentals with FlyStayGo Travel Network. Explore destinations and plan your next trip.'

            type =
                'WebSite'
        }


        /*
        |--------------------------------------------------------------------------
        | TOURS
        |--------------------------------------------------------------------------
        */

        else if (path === '/tours') {

            title =
                'Tours & Travel Experiences | FlyStayGo'

            description =
                'Explore tours and travel experiences with FlyStayGo. Discover destinations, activities and memorable things to do around the world.'
        }


        /*
        |--------------------------------------------------------------------------
        | HOTEL LANDING PAGES
        |--------------------------------------------------------------------------
        */

        else {

            const hotelMatch =
                path.match(/^\/pages\/hotels\/([^/]+)\/(.+)$/i)

            if (hotelMatch) {

                const category =
                    hotelMatch[1]

                const locationParam =
                    hotelMatch[2]

                const location =
                    locationParam.replace(/^c\d+-/i, '')

                const locationName =
                    makeSlugTitle(location)


                /*
                    * POI HOTEL PAGE
                    */

                if (locationParam.includes('~')) {

                    const poiParts =
                        locationParam.split('~', 2)

                    let poiLocation =
                        poiParts[1] || ''

                    poiLocation =
                        poiLocation.replace(/^c\d+-p-/i, '')

                    const poiName =
                        makeSlugTitle(poiLocation)


                    title =
                        'Hotels Near ' + poiName + ' | FlyStayGo'

                    description =
                        'Find hotels and places to stay near ' +
                        poiName +
                        '. Explore nearby accommodations and travel options with FlyStayGo.'

                    type =
                        'Place'
                }


                /*
                    * STANDARD HOTEL PAGE
                    */

                else {

                    switch (category) {

                        case 'booking-vacation-favorite-destination':

                            title =
                                'Hotels in ' +
                                locationName +
                                ' | FlyStayGo'

                            description =
                                'Find hotels in ' +
                                locationName +
                                ' and explore accommodations for your next vacation. Discover places to stay and plan your trip with FlyStayGo.'

                            type =
                                'Place'

                            break


                        case 'hotels-places-to-stay':

                            title =
                                'Hotels & Places to Stay in ' +
                                locationName +
                                ' | FlyStayGo'

                            description =
                                'Find hotels and places to stay in ' +
                                locationName +
                                '. Explore accommodations, lodging options and convenient places to stay with FlyStayGo.'

                            type =
                                'Place'

                            break


                        case 'best-hotels-resort-accommodations':

                            title =
                                'Best Hotels & Resort Accommodations in ' +
                                locationName +
                                ' | FlyStayGo'

                            description =
                                'Discover the best hotels and resort accommodations in ' +
                                locationName +
                                '. Explore lodging options and find places to stay for your trip with FlyStayGo.'

                            type =
                                'Place'

                            break


                        case 'cheapest-hotels-budget-deals':

                            title =
                                'Cheap Hotels & Budget Deals in ' +
                                locationName +
                                ' | FlyStayGo'

                            description =
                                'Find cheap hotels and budget-friendly accommodations in ' +
                                locationName +
                                '. Explore affordable places to stay and hotel deals with FlyStayGo.'

                            type =
                                'Place'

                            break


                        default:

                            title =
                                'Hotels in ' +
                                locationName +
                                ' | FlyStayGo'

                            description =
                                'Find hotels and accommodations in ' +
                                locationName +
                                '. Explore places to stay and plan your trip with FlyStayGo.'

                            type =
                                'Place'

                            break
                    }
                }
            }


            /*
            |--------------------------------------------------------------------------
            | TOUR LANDING PAGES
            |--------------------------------------------------------------------------
            */

            else {

                const tourMatch =
                    path.match(/^\/pages\/tours\/([^/]+)\/(.+)$/i)

                if (tourMatch) {

                    const locationParam =
                        tourMatch[2]

                    const location =
                        locationParam.replace(/^c\d+-/i, '')

                    const locationName =
                        makeSlugTitle(location)


                    title =
                        'Tours in ' +
                        locationName +
                        ' | FlyStayGo'

                    description =
                        'Explore tours and travel experiences in ' +
                        locationName +
                        '. Discover activities and things to do with FlyStayGo.'

                    type =
                        'Place'
                }
            }
        }


        /*
        |--------------------------------------------------------------------------
        | INFORMATIONAL PAGES
        |--------------------------------------------------------------------------
        */

        if (path === '/info/contact') {

            title =
                'Contact FlyStayGo | Travel Network'

            description =
                'Contact FlyStayGo Travel Network for questions, support and information about our travel services.'
        }


        else if (path === '/info/faq') {

            title =
                'Frequently Asked Questions | FlyStayGo'

            description =
                'Find answers to frequently asked questions about FlyStayGo Travel Network and its travel services.'
        }


        else if (path === '/info/privacy') {

            title =
                'Privacy Policy | FlyStayGo'

            description =
                'Read the FlyStayGo privacy policy and learn how information is handled when using our travel network.'
        }


        else if (path === '/info/terms') {

            title =
                'Terms of Service | FlyStayGo'

            description =
                'Read the FlyStayGo Terms of Service governing use of the FlyStayGo travel network and website.'
        }


        /*
        |--------------------------------------------------------------------------
        | PRIVATE / TRANSACTIONAL PAGES
        |--------------------------------------------------------------------------
        */

        else if (
            path === '/dashboard' ||
            path === '/my-profile' ||
            path === '/hotel-search' ||
            path === '/tour-search' ||
            path === '/hotel-details' ||
            path === '/room-booking' ||
            path === '/booking-confirmation'
        ) {

            robots =
                'noindex, nofollow'
        }


        /*
        |--------------------------------------------------------------------------
        | ERROR / UNKNOWN PAGES
        |--------------------------------------------------------------------------
        */

        else if (
            path === '/error' ||
            path === '/coming-soon'
        ) {

            robots =
                'noindex, follow'
        }


        /*
        |--------------------------------------------------------------------------
        | JSON-LD
        |--------------------------------------------------------------------------
        */

        let schema = {

            '@context':
                'https://schema.org',

            '@type':
                type,

            name:
                title,

            url:
                canonical,

            description:
                description
        }


        /*
            * Home page uses WebSite schema.
            */

        if (path === '/') {

            schema = {

                '@context':
                    'https://schema.org',

                '@type':
                    'WebSite',

                name:
                    'FlyStayGo',

                url:
                    'https://flystaygo.com/',

                description:
                    description
            }
        }


        /*
        |--------------------------------------------------------------------------
        | Complete Dynamic Head
        |--------------------------------------------------------------------------
        */

        return {

            title,

            meta: [

                {
                    name: 'description',
                    content: description
                },

                {
                    name: 'robots',
                    content: robots
                },

                {
                    property: 'og:title',
                    content: title
                },

                {
                    property: 'og:description',
                    content: description
                },

                {
                    property: 'og:url',
                    content: canonical
                },

                {
                    name: 'twitter:title',
                    content: title
                },

                {
                    name: 'twitter:description',
                    content: description
                }
            ],

            link: [

                {
                    rel: 'canonical',
                    href: canonical
                }
            ],

            script: [

                {
                    type: 'application/ld+json',
                    children: JSON.stringify(schema)
                }
            ]
        }
    }
        

const Seo = {

    install(app) {

        const service = {

        /*
         * Make the service available as:
         *
         * this.$seo
         */
            getHead
        }
        app.config.globalProperties.$seo = service

        return service
    }
}


/*
|--------------------------------------------------------------------------
| Vue / Unhead SEO Hook
|--------------------------------------------------------------------------
|
| This is called once from App.vue.
| It automatically reacts whenever Vue Router changes.
|--------------------------------------------------------------------------
*/

export function useSeo() {

    useHead(
        computed(() => {
            return getHead(router.currentRoute.value)
            //return Seo.getHead(router.currentRoute.value)

        })
    )
}


export default Seo
